export const REMINDER_ACTION_PAYMENT = 0;
export const REMINDER_ACTION_RETRY = 1;
export type ReminderAction = typeof REMINDER_ACTION_PAYMENT | typeof REMINDER_ACTION_RETRY;
export type ReminderCollectionStatus = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
export const reminderCollectionStatusKey = (status: ReminderCollectionStatus): string => ({
  1: "Retry notification required", 2: "Retry collection scheduled", 3: "Retry collection submitted",
  4: "Retry collection processing", 5: "Retry collection missed", 6: "Retry collection cancelled", 7: "Retry collection failed",
  8: "Retry amount changed"
})[status];
